import 'jquery-lazy';
import './vendors/jquery-lazy-mb';
import 'slick-carousel/slick/slick.js';
import './vendors/jquery-ui.js';
import './vendors/jquery-inview.js';

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that tch. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $(".lazy").Lazy();
        // Generate boostrap like classes per media breakpoint for lazy e.g. .lazy-sm-down or .lazy-md-up
        $.Lazy.media_breakpoints();
      },
      finalize: function() {

      	if($("html").attr("lang") == "sv-SE") {
					// Date Picker language
					$.datepicker.regional['sv'] = {
					  closeText: 'Stäng',
						prevText: '< Föregående',
						nextText: 'Nästa >',
						currentText: 'Nu',
						monthNames: ['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December'],
					  	monthNamesShort: ['Jan','Feb','Mar','Apr','Maj','Jun','Jul','Aug','Sep','Okt','Nov','Dec'],
						dayNamesShort: ['Sön','Mån','Tis','Ons','Tor','Fre','Lör'],
						dayNames: ['Söndag','Måndag','Tisdag','Onsdag','Torsdag','Fredag','Lördag'],
						dayNamesMin: ['Sö','Må','Ti','On','To','Fr','Lö'],
						weekHeader: 'Не',
						dateFormat: 'D d M yy',
						firstDay: 1,
						isRTL: false,
						showMonthAfterYear: false,
						yearSuffix: ''
					};
					$.datepicker.setDefaults($.datepicker.regional['sv']);
      	}

				$("[data-filter].category").click(function(e) {
      		e.preventDefault();
      		//$(".override").text("");
      		$(".filter .filter-tag.category").removeClass("active");
      		$(".filter [data-filter='" + $(this).data("filter") + "'].category").toggleClass("active");
      		filterItems();
      	});

				$(".mobile-category").change(function(e) {
      		$(".filter-tag.category").removeClass("active");
      		$(".filter [data-filter='" + $(this).val() + "'].category").toggleClass("active");
      		$("#active-cat-mobile").text($(this).find('option:selected').text());
      		filterItems();
      	});

      	$(".packages, .package-highlight").on("click", function() {
          if($(this).find(".read-more-link").length > 0) {
            document.location = $(this).find(".read-more-link").attr("href");
          }
 		    });

      	$("[data-filter].season").click(function(e) {
      		e.preventDefault();
      		//$(".override").text("");
      		$(".filter-tag.season").removeClass("active");
      		$(this).toggleClass("active");
      		filterItems();
      	});

        $(".dropdown-btn").click(function(){
          $(this).toggleClass("show");
          $(this).find(".categories-dropdown").slideToggle("fast");
        });

        function filterItems() {
        	$(".filter-item, #popular, span.default").hide();
        	$(".override").text("");

        	var active_classes = [];

        	var active_season = $("[data-filter].season.active").data("filter");
        	if(active_season) {
        		active_classes.push(active_season);
        	}

        	var active_category = $("[data-filter].category.active").data("filter");
        	if(active_category) {
        		$(".override").text($("[data-filter].category.active").text());
        		active_classes.push(active_category);
        	} else {
        		$("span.default").show();
        	}

        	var selector = active_classes.join(".");
        	if(selector) selector = "." + selector;

        	$(".filter-item" + selector).show();
        }

        // SEO Content
        $('.btn-readmore').click(function() {
        	$(this).parents(".seo-text").find('.readmore-content').slideDown('fast'); 
          $(this).remove();
          return false;
        });

					$(window).scroll(function(){
						if($(window).scrollTop() >= 110 && $(window).width() >= 768){
							$('header.header').addClass('sticky');
							$('.sticky-header-spacer').show();
						}else {
							$('header.header').removeClass('sticky');
							$('.sticky-header-spacer').hide();
						}
					});

	        $(".language-switcher").click(function(){
	          $(this).toggleClass("open");
	          $(this).find(".options").slideToggle("fast");
	        });

          $(".hamburger-menu").click(function(){
          	$(this).toggleClass("active");
            $("body").toggleClass("mobile-menu-active");
            $('#main-menu').slideToggle(300);
          });

          $('.mobile-menu-icon').click( function(){
            $(this).parent('.menu-item').find('.level-2').slideToggle("fast");
            $(this).parent('.menu-item').toggleClass('open');
          });

          /*$('.visit').click( function() {
            $(this).toggleClass('active');
            $('#widgetContainer').slideToggle('fast');
          });*/

          $('#booking').click(function(){
            $(this).find('.icon-arrow-triagle').toggleClass('icon-arrow-active');
            $('.box-list-items').slideToggle();
            if ($(this).attr("data-string") == 1) {
              $(this).text("Stäng");
              $(this).attr("data-string",2);
            }else{
              $(this).text("När vill du besöka oss?");
              $(this).attr("data-string",1);
            }
          });

          $('.gallery-img-size').click( function(){
            $('.gallery-img-size').toggleClass('img-active');
          });

          /*-- offers component --*/
          $('.dropdown-icon').click( function() {
            $(this).toggleClass('active');
          });
          /*-------*/

          /*-- form-box component --*/
          $('.input-form').click( function() {
            $(this).toggleClass('active');
          });
          /*-------*/
             
          $('.testimony-content').bindInView(function(event, isInView) {
            if(isInView) {
              if (!$(this).hasClass("inview")) {
                $(this).slick({
                  dots: true,
                  infinite: true,
                  speed: 300,
                  slidesToShow: 1,
                  centerMode: false,
                  variableWidth: false,
                  autoplay: false,
                  arrows: false
                });

                $(this).addClass("inview");
              }
            }
          });



        $('.img-slide').bindInView(function(event, isInView) {
          if(isInView) {
            if (!$(this).hasClass("inview")) {
              $(this).slick({
                dots: true,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                centerMode: false,
                lazyLoad: 'ondemand',
                variableWidth: false,
                autoplay: false,
                arrows: true,
                prevArrow: '<img class="arrows left" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAXVBMVEVHcEz///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+EHRzTAAAAHnRSTlMA7e/7Mzgy8DfuAyb4vwQCNTS09+fxsyetHPnAprVeO/EYAAABJklEQVRo3u3YyQ6CMBSFYQSViiA4z7z/Y2pIlFamDuduzPlX5C74UsLmNooYY4wxxhiT7Po4HC9rWUOt6nexkjTmjVHX6ULekFRaQ07RDSnFNGSUX0NC6Rp4RaXtq7VHJXSOVC1nImcxjCgSUX4MEaVjCCg9BlzpNcDKgAFVBg2gMmLAlFEDpEwYEGXSACgWRrBiZQQqlkaQYm0EKA6Gt+JkeCqOhpfibHgoHoaz4mU4Kp6Gk+JtOCgBhrUSZFgqgYaVEmxYKABjUoEYEwrIGFXOMWzp0FaZ2LxVeAIXG03Z6fPshlye2i+WZ9p4k0AXtK+SbPTxHbsEfr5YYUyrPfZiRjU/0n5rTqsiyU/AK6b1Lk+KbWeclditvMx4O8gYY4wx9o+9AEL9YZD7OIM3AAAAAElFTkSuQmCC">',
                nextArrow: '<img class="arrows right" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAXVBMVEVHcEz///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+EHRzTAAAAHnRSTlMA7e/7Mzgy8DfuAyb4vwQCNTS09+fxsyetHPnAprVeO/EYAAABJklEQVRo3u3YyQ6CMBSFYQSViiA4z7z/Y2pIlFamDuduzPlX5C74UsLmNooYY4wxxhiT7Po4HC9rWUOt6nexkjTmjVHX6ULekFRaQ07RDSnFNGSUX0NC6Rp4RaXtq7VHJXSOVC1nImcxjCgSUX4MEaVjCCg9BlzpNcDKgAFVBg2gMmLAlFEDpEwYEGXSACgWRrBiZQQqlkaQYm0EKA6Gt+JkeCqOhpfibHgoHoaz4mU4Kp6Gk+JtOCgBhrUSZFgqgYaVEmxYKABjUoEYEwrIGFXOMWzp0FaZ2LxVeAIXG03Z6fPshlye2i+WZ9p4k0AXtK+SbPTxHbsEfr5YYUyrPfZiRjU/0n5rTqsiyU/AK6b1Lk+KbWeclditvMx4O8gYY4wx9o+9AEL9YZD7OIM3AAAAAElFTkSuQmCC">',
              });
      
              $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
                $(this).parents(".gallery").find('img[data-slide]').removeClass("active");
                $(this).parents(".gallery").find('img[data-slide="' + nextSlide + '"]').toggleClass("active");
              });
      
              $(this).on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
                  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                  var i = (currentSlide ? currentSlide : 0) + 1;
                  $('.show-img-amount').text(i + ' av ' + slick.slideCount);
              });

              $(this).addClass("inview");

            }
          }
        });
        

        $('img[data-slide]').click(function(e) {
          e.preventDefault();
          var slideno = $(this).data('slide');
          $(this).parents(".gallery").find('.img-slide').slick('slickGoTo', slideno);
        });

        var months = ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'];
        var weekDays = [ 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör', 'Sön'];
           
        $(".datepicker").bindInView(function(event, isInView) {
          if(isInView) {
            if (!$(this).hasClass("inview")) {
                $(this).datepicker({
                 minDate: 0
                });

                $(this).addClass("inview");
            }
          }
        });


        $(".mobile-readmore").click(function(){
          $(this).hide();
          $(this).parents(".content-all").find(".content-text").addClass("open");
        });

        $(".content-read-more .read-more").click(function(){
          $(this).parent().addClass("open");
        });

        /* block text & slideshow */

        function updateSlideIndex(slick, currentSlide) {
          $(slick.$slider).closest('.text-slideshow-container').find('.slide-counts span').text(currentSlide + 1);
        }

        $('.slideshow-images').bindInView(function(event, isInView) {
          if(isInView) {
            if (!$(this).hasClass("inview")) {
              $(this).slick({
                slidesToShow: 1.5,
                slidesToScroll: 1,
                lazyLoad: 'ondemand',
                arrows: true,
                infinite: false,
                prevArrow: '<div class="arrow-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15.319" height="12.292" viewBox="0 0 15.319 12.292"><defs><style>.a,.c{fill:none;}.b{clip-path:url(#a);}.c{stroke-linecap:round;stroke-width:2px;}</style><clipPath id="a"><rect class="a" width="15.319" height="12.292"/></clipPath></defs><g class="b"><path class="c" d="M614.52,639l5.146,5.676L624.811,639" transform="translate(-630.846 625.811) rotate(-90)"/><line class="c" x1="12" transform="translate(1 6.308)"/></g></svg></div>',
                nextArrow: '<div><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15.319" height="12.292" viewBox="0 0 15.319 12.292"><defs><style>.a,.c{fill:none;}.b{clip-path:url(#a);}.c{stroke-linecap:round;stroke-width:2px;}</style><clipPath id="a"><rect class="a" width="15.319" height="12.292"/></clipPath></defs><g class="b"><path class="c" d="M614.52,639l5.146,5.676L624.811,639" transform="translate(-630.846 625.811) rotate(-90)"/><line class="c" x1="12" transform="translate(1 6.308)"/></g></svg></div>',
              });

              $(this).on('afterChange', function(event, slick, currentSlide){
                updateSlideIndex(slick, currentSlide);
              });

              $(this).addClass("inview")
            }
          }
        });
      }
    },

    'page_template_erbjudanden': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {

      }
    },

    'page_template_konferens': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
      	//$('.form-section').first().attr('id', 'conference-form');
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.



//////////////////
// WEBPACK FOOTER
// ./assets/js/main.js
// module id = 67
// module chunks = 0